import { api } from "./api";

const KEY = "hiplate-session";

export const getSessionId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, "");
    localStorage.setItem(KEY, id);
  }
  return id;
};

let timer;
/** Report the visitor's current bundle to the kitchen (debounced; fire-and-forget). */
export const trackBasket = (cart, mealCount) => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    api.post("/activity/basket", {
      session_id: getSessionId(),
      items: cart.map(({ item, qty }) => ({ name: item.name, qty, price: item.price })),
      meal_count: mealCount,
    }).catch(() => {});
  }, 1500);
};

/** First-party page-view ping (no cookies); admin pages are ignored server-side. */
export const trackPageview = (path) => {
  api.post("/activity/pageview", {
    session_id: getSessionId(),
    path,
    referrer: document.referrer || "",
    screen_w: window.innerWidth,
  }).catch(() => {});
};
